<template>
  <div v-if="this.status">
    <div style="padding-top: 0.1em; padding-bottom: 0.1rem" :class="'text-xs px-3 bg-'+color+'-200 text-'+color+'-800 rounded'">{{ $t('status.'+this.status.name) }}</div>
  </div>
</template>
<script>
export default{
  props: {
    status: Object,
  },
  computed:{
    color(){
      let color = 'orange'
      switch (this.status.value) {
      case 1:
        color = 'orange'
        break
      case 2:
        color = 'green'
        break
      case 3:
        color = 'red'
        break
      }
      return color
    },
  },
}
</script>
